import { liveTimeline } from "@/mocks/gossip";

export default function LiveTimeline() {
  return (
    <section id="live" className="w-full scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
            <i className="ri-radar-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            围观现场
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">围观现场 · 今日讨论时间线</h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-600">
            社区把一天当中热度上升较快的话题按时间顺序串联起来，方便你快速回看事情是怎么一步步被讨论起来的。
          </p>
        </div>

        <ol className="relative mt-8 border-l border-background-300 pl-6 md:pl-8">
          {liveTimeline.map((event, index) => (
            <li key={index} className="relative pb-7 last:pb-0">
              <span className="absolute -left-[31px] md:-left-[39px] top-1 flex items-center justify-center w-4 h-4 rounded-full border-2 border-background-100 bg-primary-500"></span>
              <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="font-medium text-foreground-800">{event.time}</span>
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">{event.tag}</span>
                </div>
                <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-950">{event.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{event.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}